import React from "react";
import { useCallback, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";
import useRoutesHelper from "../../../../../hooks/useRoutesHelper";
import {
  fetchCargoCar,
  postFinishDelivery,
} from "../../../../../redux/api/raports.api";
import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../../../helpers/apiHelper";
import { closeFinishingDeliveryModal } from "../../../../../redux/reducer/raports.reducer";
import ModalWrapper from "../../../../../components/Modal/ModalWrapper";
import CustomButton from "../../../../../components/CustomButton";
import Text from "../../../../../styleguide/Text";
import {
  ceilToMinute,
  dateAndTimeForDatabase,
} from "../../../../../utils/dateAndTime";
import DateTimePicker from "../../../../../components/misc/DateTimePicker";

function FinishDeliveryModal() {
  const dispatch = useAppDispatch();
  const { routeParams } = useRoutesHelper();

  const {
    raports: { isFinishingDeliveryModalOpen, selectedFinishingDeliveryData },
  } = useAppSelector((state) => ({
    raports: state.raports,
  }));

  const [isLoading, setIsLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const minimumDate = ceilToMinute(
    selectedFinishingDeliveryData?.data_incarcare,
  );
  const isSubmitDisabled =
    !selectedFinishingDeliveryData?.id_transport_marfa ||
    !selectedDate ||
    isLoading;

  const handleOnSubmit = useCallback(
    async ({ handleClose }: any) => {
      if (isSubmitDisabled || !selectedFinishingDeliveryData) {
        return;
      }
      setIsLoading(true);

      const tryFinish = async (payload: {
        id_transport_marfa: number;
        id_bin?: number;
        id_colet?: number;
        data_finalizarii: string;
      }) => {
        const resultAction = await dispatch(postFinishDelivery(payload));

        if (
          checkEndpointStatus(resultAction, postFinishDelivery) ===
          endpointStatus.fulfilled
        ) {
          const { page, rowsPerPage, idAuto } = routeParams;

          dispatch(
            fetchCargoCar({
              page: page,
              perPage: rowsPerPage,
              idAuto: idAuto,
            }),
          );
        }
      };

      const { id_bin, id_transport_marfa, id_colet } =
        selectedFinishingDeliveryData;

      if (id_bin) {
        await tryFinish({
          id_transport_marfa,
          id_bin,
          data_finalizarii: dateAndTimeForDatabase(selectedDate),
        });
      } else if (id_colet) {
        await tryFinish({
          id_transport_marfa,
          id_colet,
          data_finalizarii: dateAndTimeForDatabase(selectedDate),
        });
      }

      dispatch(closeFinishingDeliveryModal());
      setSelectedDate(null);
      setIsLoading(false);

      handleClose && handleClose();
    },
    [
      selectedFinishingDeliveryData,
      dispatch,
      selectedDate,
      routeParams,
      isSubmitDisabled,
    ],
  );

  const onClose = useCallback(() => {
    dispatch(closeFinishingDeliveryModal());
    setSelectedDate(null);
  }, [dispatch]);

  const modalTitleWithBin = `Finalizarea livrarii pt. binul ${
    selectedFinishingDeliveryData && selectedFinishingDeliveryData.id_bin
  }`;
  const modalTitleWithAwb = `Finalizarea livrarii pt. coletul ${
    selectedFinishingDeliveryData && selectedFinishingDeliveryData.doc_trans
  }`;
  return (
    <>
      <ModalWrapper
        show={!!isFinishingDeliveryModalOpen}
        title={
          selectedFinishingDeliveryData && selectedFinishingDeliveryData.id_bin
            ? modalTitleWithBin
            : modalTitleWithAwb
        }
        modalSize="sm"
        handleClose={onClose}>
        <div className="flex flex-col">
          <DateTimePicker
            label="Data si ora finalizarii"
            value={selectedDate}
            minDate={minimumDate}
            defaultTimeToNow
            handleChangeDate={(newDate) => setSelectedDate(newDate)}
          />
        </div>

        <CustomButton
          type="submit"
          variant="contained"
          fullWidth
          className="mt-5 w-full"
          disabled={isSubmitDisabled}
          loading={isLoading}
          onClick={handleOnSubmit}>
          <Text variant="body1" isBold>
            Salveaza
          </Text>
        </CustomButton>
      </ModalWrapper>
    </>
  );
}

export default FinishDeliveryModal;
